<template>
  <b-card
    class="card mb-2"
    header-tag="header"
    body-class="p-3"
    border-variant="secondary"
    header-border-variant="secondary"
    @click.stop="clickItem"
    @mouseover="showBotaoExcluir = true"
    @mouseleave="showBotaoExcluir = false"
  >
    <template #header>
      <b-row>
        <b-col cols="10" class="align-self-center">{{ item.detalhe }}</b-col>
        <b-col cols="2" class="text-right" :class="!showBotaoExcluir ? 'invisible' : 'visible'">
          <fcc-button
            @click.stop="deleteItem"
            icon="trash"
            color="outline-danger"
            class="m-0 px-2"
            size="sm"
          ></fcc-button>
        </b-col>
      </b-row>
    </template>
    <div><strong>Dificuldade: </strong>{{ item.descricaodificuldade }}</div>
    <div><strong>Responsável: </strong>{{ item.responsavel?.nomeresponsavel }}</div>
    <b-badge :variant="variants[wrap(item?.equipe?.idequipe - 1)]">{{
      item?.equipe?.descricaoequipe
    }}</b-badge>
  </b-card>
</template>
<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      showBotaoExcluir: false,
      variants: ['primary', 'secondary', 'light', 'danger', 'warning', 'info', 'success', 'dark']
    }
  },
  methods: {
    clickItem(e) {
      if (document.getSelection().type === 'Range') e.stopPropagation()
      else this.$emit('click-item', this.item)
    },
    deleteItem() {
      this.$emit('delete-item', this.item)
    },
    wrap(num) {
      return ((num - 1) % 8) + 1
    }
  }
}
</script>